import StellaTestingJourney from './pages/StellaTestingJourney';

function App() {
  return (
    <div className="App">
        <StellaTestingJourney/>
    </div>
  );
}

export default App;
